import preprocessResponse from 'ha/utils/preprocessResponse';
import reportError from 'ha/helpers/bugsnag/reportError';

export default () => {
  // webpack-svgstore-plugin replaces __svg__ by `{ filename: String }` at build time
  // docs: https://github.com/mrsum/webpack-svgstore-plugin
  // eslint-disable-next-line
  const __svg__ = { path: '../../img-src/svg-icons/**/*.svg' };

  return fetch(__svg__.filename)
    .then(preprocessResponse)
    .then(response => {
      if (!response || response.substr(0, 4) !== '<svg') {
        throw Error('Invalid SVG Response');
      }

      const svgContainer = document.body.insertBefore(
        document.createElement('div'),
        document.body.childNodes[0],
      );

      // eslint-disable-next-line no-param-reassign
      svgContainer.innerHTML = response;
    })
    .catch(reportError);
};
